import { Component, OnInit, ViewChild } from '@angular/core';
import { ChaseTransactionLogsService } from './Service/chase-transaction-logs-service';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Table } from 'primeng/table';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-chase-transaction-logs',
  templateUrl: './chase-transaction-logs.component.html',
  styleUrls: ['./chase-transaction-logs.component.css'],
  providers: [ChaseTransactionLogsService]
})

export class ChaseTransactionLogsComponent implements OnInit {
  getChaseTransactionDetails: any[]=[];
  loadingChaseTransactionLogs: boolean;

  constructor(private ChaseTransactionLogsService:ChaseTransactionLogsService) { }

  ngOnInit() {
    this.GetChaseTransactionLogsGrid();   
  }
  
  GetChaseTransactionLogsGrid() {
    this.loadingChaseTransactionLogs = true;
    this.ChaseTransactionLogsService.GetChaseTransactionLogs().subscribe(
      p => {
        this.getChaseTransactionDetails = p
        this.loadingChaseTransactionLogs = false; 
      }
    );
  }
  
}
 


// WEBPACK FOOTER //
// ./src/app/chase-transaction-logs/chase-transaction-logs.component.ts